export class ServicePlanRateBO {
    servicePlanRateId: string="00000000-0000-0000-0000-000000000000";
    normalRate: number;
    enhancedRate: number;
    pTOTax_Percent: number;
    ptoTax_Percent: number = 0;
    payrollTax_Percent: number = 0;
}